import { useEffect, useRef } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useSidebarLayout } from '../../app-shell/context/SidebarProvider';

/**
 * Collapses the app sidebar on the report builder so form and preview
 * can sit side by side. Restores the previous sidebar state on leave.
 */
export default function useAnalyticsBuilderLayout() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const { collapsed, setCollapsedState } = useSidebarLayout();
  const sidebarBeforeRef = useRef(null);
  const collapsedRef = useRef(collapsed);

  useEffect(() => {
    collapsedRef.current = collapsed;
  }, [collapsed]);

  useEffect(() => {
    if (!isDesktop) {
      return undefined;
    }

    if (sidebarBeforeRef.current === null) {
      sidebarBeforeRef.current = collapsedRef.current;
    }
    setCollapsedState(true);

    return () => {
      if (sidebarBeforeRef.current !== null) {
        setCollapsedState(sidebarBeforeRef.current);
        sidebarBeforeRef.current = null;
      }
    };
  }, [isDesktop, setCollapsedState]);
}
